import { isNodeSelection } from '@tiptap/core'
import { Selection as TiptapSelection } from '@tiptap/extensions'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

/**
 * Keeps the selection highlighted while focus is elsewhere, for example in the
 * comment composer. TipTap's Selection skips read-only editors, but its CSS
 * still hides their native selection, so read-only text had no highlight.
 * @see https://github.com/ueberdosis/tiptap/blob/v3.27.1/packages/extensions/src/selection/selection.ts
 */
export const Selection = TiptapSelection.extend({
  addProseMirrorPlugins() {
    const { editor, options } = this
    // Keeps the parent's injected CSS, which hides the unfocused native selection
    this.parent?.()

    return [
      new Plugin({
        key: new PluginKey('selection'),
        props: {
          decorations(state) {
            if (
              state.selection.empty ||
              editor.isFocused ||
              isNodeSelection(state.selection) ||
              editor.view.dragging
            ) {
              return null
            }

            return DecorationSet.create(state.doc, [
              Decoration.inline(state.selection.from, state.selection.to, {
                class: options.className,
              }),
            ])
          },
        },
      }),
    ]
  },
})
